import type { TableColumns } from '@ohpen/enso-ui';
import { ExclusivitySetResponse, FieldType } from '@pmp/api';

export const exclusiveSetsColumns: TableColumns<ExclusivitySetResponse> = [
  {
    title: 'pmp.exclusiveProducts.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.name',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.description',
    dataIndex: 'description',
    key: 'description',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firmIds',
    dataIndex: 'lenderFirms',
    key: 'firmIds',
    options: {
      format: {
        type: 'multiValueListKey',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'pmp.exclusiveProducts.labels.firms',
    dataIndex: 'lenderFirms',
    key: 'firms',
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
